import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import { Payroll } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import AddEmployeeToPayrollForm from '@/components/salary/AddEmployeeToPayrollForm.vue';
    import { router } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AddEmployeeToPayroll',
  props: {
    payroll: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        employee_id: null,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.salary.payrolls.add-employee', { payroll: props.payroll.id }),
    "query-key": [_unref(QueryKey).PAYROLL, selectedCompanyId.value, props.payroll.id],
    title: "payrolls.add_employee_to_payroll.header",
    "button-text": "payrolls.other_buttons.add_employee_to_payroll",
    "submit-text": "payrolls.add_employee_to_payroll.add_employee",
    "success-message": "payrolls.edit.employee_added_to_payroll",
    disabled: props.disabled
  }, {
    default: _withCtx(() => [
      _createVNode(AddEmployeeToPayrollForm, {
        form: _unref(form),
        payroll: props.payroll
      }, null, 8, ["form", "payroll"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "disabled"]))
}
}

})